import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { makeFieldStyleSelector } from "../selectors";
import { setActiveItem } from "./actions";
import Component, { type ActionProps, type KnoledgeBaseComponentProps } from "./component";
import { localStateSelector, makeStyleSelector } from "./selectors";
import { type KnowledgeBase } from "./types";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector();
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["navigationType", "columns"]);

  return (state: AppState, props: RootContainerProps): KnoledgeBaseComponentProps => {
    const settings = settingsSelector(state, props);
    const styleSelector = makeStyleSelector();

    return {
      ...props,
      ...settings,
      ...localStateSelector(state, props),
      fieldStyle: fieldStyleSelector(state, props),
      style: styleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  setActiveItem: (activeItem: KnowledgeBase.View.ActiveItem | null) => dispatch(setActiveItem({ ...props, activeItem }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
